import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import { Switch } from "@headlessui/react";
var SwitchToggle = function SwitchToggle(_ref) {
  var _ref$value = _ref.value,
    value = _ref$value === void 0 ? false : _ref$value,
    _ref$onChange = _ref.onChange,
    onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$thumbClassName = _ref.thumbClassName,
    thumbClassName = _ref$thumbClassName === void 0 ? "" : _ref$thumbClassName;
  return /*#__PURE__*/React.createElement(Switch, {
    checked: value,
    onChange: !disabled ? onChange : undefined,
    onClick: function onClick(event) {
      return event.stopPropagation();
    },
    className: classNames("relative inline-flex h-[16px] w-[30px] flex-shrink-0 cursor-pointer rounded-full border border-gray-400 dark:border-gray-500 transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2", {
      "bg-gray-900 dark:bg-black": !value,
      // Dark track when inactive (OFF)
      "opacity-50 !cursor-not-allowed": disabled
    })
  }, /*#__PURE__*/React.createElement("span", {
    className: classNames("pointer-events-none relative inline-block h-[18px] w-[18px] transform rounded-full shadow-lg ring-0 transition duration-200 ease-in-out translate-y-[-2px]", _defineProperty({
      "translate-x-[12px]": value,
      // Right position when active (ON)
      "translate-x-[-1px]": !value,
      // Right position when active (ON)
      "bg-teal-500": value,
      // Bright teal thumb when active (ON)
      "bg-gray-600 dark:bg-gray-700": !value
    }, thumbClassName, !!thumbClassName && value))
  }));
};
export default SwitchToggle;